import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment, UrlSegmentGroup, Route } from '@angular/router';

export function invoiceFolioMatcher(segments: UrlSegment[], _group: UrlSegmentGroup, _route: Route): UrlMatchResult | null {
    if (segments.length === 3
        && segments[0].path === 'list'
        && segments[1].path.startsWith('folio-')
        && segments[2].path === 'view') {
        const folio = segments[1].path.substring('folio-'.length);
        return {
            consumed: segments,
            posParams: { folio: new UrlSegment(folio, {}) }
        };
    }
    return null;
}
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { OrderAddComponent } from './order-add/order-add.component';
import { OrderListComponent } from './order-list/order-list.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OrderChangedUnitComponent } from './order-changed-unit/order-changed-unit.component';
import { ExpenseReportFormComponent } from './expense-report-form/expense-report-form.component';
import { BillServiceComponent } from './bill-service/bill-service.component';
import { InvoiceViewComponent } from './invoice-view/invoice-view.component';
import { ExpenseSummaryComponent } from './expense-summary/expense-summary.component';
import { ExpenseValidationComponent } from './expense-validation/expense-validation.component';
import { DepositsListComponent } from './deposits-list/deposits-list.component';
import { DepositFormComponent } from './deposit-form/deposit-form.component';

const routes: Routes = [
    {
        path: "service", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
            path: "add", component: OrderAddComponent, data: { module: "Servicio", accion: "Crear Servicio", type: "add" }
        }, {
            path: "list", component: OrderListComponent, data: { module: "Servicio", accion: "Listado de Servicios", type: "list" }
        }, {
            path: "detail", component: OrderDetailComponent, data: { module: "Servicio", accion: "Detalle del servicio", type: "detail" }
        }, {
            path: "changed-unit", component: OrderChangedUnitComponent, data: { module: "Servicio", accion: "Editar servicio", type: "changed-unit" }
        }, {
            path: "expense-report/:id", component: ExpenseReportFormComponent, data: { module: "Servicio", accion: "Registro de viáticos", type: "expense-report" }
        }, {
            path: "bill-service", component: BillServiceComponent, data: { module: "Servicio", accion: "Facturar Servicio", type: "bill-service" }
        }, {
            matcher: invoiceFolioMatcher, component: InvoiceViewComponent, data: { module: "Servicio", accion: "Factura de servicio", type: "invoice-view" }
        }, {
            path: "expense-summary/:id", component: ExpenseSummaryComponent, data: { module: "Servicio", accion: "Resumen de gastos", type: "expense-summary" }
        }, {
            path: "expense-validation/:id", component: ExpenseValidationComponent, data: { module: "Servicio", accion: "Validación de gastos", type: "expense-validation" }
        }, {
            path: "deposits", component: DepositsListComponent, data: { module: "Servicio", accion: "Control de gastos", type: "deposits" }
        }, {
            path: "deposit/:id", component: DepositFormComponent, data: { module: "Control de gastos", accion: "Registro de viáticos / Editar o Agregar nuevo deposito", type: "deposit" }
        }]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OrderRoutingModule { }
